import { render, staticRenderFns } from "./mineAltas.vue?vue&type=template&id=75a9da96&scoped=true&"
import script from "./mineAltas.vue?vue&type=script&lang=js&"
export * from "./mineAltas.vue?vue&type=script&lang=js&"
import style0 from "./mineAltas.vue?vue&type=style&index=0&id=75a9da96&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75a9da96",
  null
  
)

export default component.exports